import { FC } from 'react';

import { Center, IconProps, InformationCircleSolid, Tooltip } from '@bonusly/design-system';

interface InfoTooltipProps extends IconProps {
	children: string;
	isDisabled?: boolean;
}

export const InfoTooltip: FC<InfoTooltipProps> = ({ children, isDisabled = false, ...rest }) => {
	return (
		<Tooltip as="span" display="block" hasArrow isDisabled={isDisabled} label={children} placement="top">
			<Center as="span" cursor="pointer">
				<InformationCircleSolid transitionDuration="0.2s" transitionProperty="color" size="sm" color="info.icon" _hover={{ color: 'gray.700' }} {...rest} />
			</Center>
		</Tooltip>
	);
};
